;
define("recently_viewed_cell.tpl", function(){});

